<template>
  <div class="content-wrapper">
    <div class="guide">
      <span>您的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }"> <span style="color: #fff;">首页</span> </el-breadcrumb-item>
        <el-breadcrumb-item><span style="color: #fff;">满意度调查</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="info">
      <div v-if="!questionsContent.template || !questionsContent.template.length" style="text-align: center;padding-top: 68px;height: 300px;">
        <img src="@/assets/img/noData.png">
        <p style="margin: 10px 0;">暂无问卷调查</p>
      </div>
      <div class="title" v-if="questionsContent.template && questionsContent.template.length>0">
        <h1 style="font-size: 24px;margin-bottom: 13px;">{{questionsContent.title || '---'}}</h1>
        <p style="color: #666;">{{questionsContent.detail}}</p>
      </div>
      <div class="items" v-for="item in questionsContent.template" :key="item.sort">
        <h3><span>{{item.options.required ? '*' : ''}}</span>{{item.sort>=9 ? item.sort+1 : '0'+(item.sort+1)}}&emsp;{{item.label}}</h3>
        <p style="color: #666;padding-left: 38px;">{{item.detail}}</p>
        <template v-if="item.type == 'input'">
          <el-input :disabled="questionsContent.isFill" type="textarea" :rows="1" placeholder="请填写" v-model="item.answer"></el-input>
        </template>
        <template v-if="item.type == 'radio'">
          <el-radio-group v-model="item.answer" :disabled="questionsContent.isFill">
            <el-radio v-for="v in item.options.valueData" :key="v.code" :label="String(v.code)">{{v.label}}</el-radio>
          </el-radio-group>
        </template>
        <template v-if="item.type == 'check'">
          <el-checkbox-group v-model="item.answer" :disabled="questionsContent.isFill">
            <el-checkbox v-for="v in item.options.valueData" :key="v.code" :label="String(v.code)">{{v.label}}</el-checkbox>
          </el-checkbox-group>
        </template>
        <template v-if="item.type == 'image'">
          <ul style="display:inline-block;margin-top: 22px;padding-left: 38px;" class="upload-list">
            <li v-for="(v,i) in item.answer" :key="i">
              <img :src="getUrl(v)">
              <img v-if="!questionsContent.isFill" @click="delImg(i,item.answer)" class="del" src="@/assets/img/del.png"/>
            </li>
            <li v-if="!questionsContent.isFill">
              <el-upload :headers="headerSet" :show-file-list="false" name="file" accept=".png,.jpg,.jpeg" multiple class="uploader" :action="action"
                :on-success="(res)=>{handleAvatarSuccess(res,item.answer)}">
                <i class="el-icon-plus"></i>
                <span style="color:#999;">上传图片</span>
              </el-upload>
            </li>
          </ul>
        </template>
      </div>
    </div>
    <div class="bottom_btns" v-if="questionsContent.template.length>0">
      <el-button style="margin-right: 10px;" round @click="$router.push({ name: 'home' })">取消</el-button>
      <el-button type="primary" v-if="!questionsContent.isFill" round @click="upHandle" v-loading="submitting">提交</el-button>
      <el-button type="primary" v-if="questionsContent.isFill==true" round @click="questionsContent.isFill=false;" v-loading="submitting">重新填写</el-button>
    </div>
  </div>
</template>

<script>
import { previewUrl } from "@/utils";
export default {
  data() {
    return {
      submitting:false,
      imgList: [],
      checkList: [],
      questionsContent:{
        template:[]
      },
      action:window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/upload'
    };
  },
  created() {
    this.getList();
  },
  computed:{
    headerSet() {
      return { 'X-Admin-Token': this.$cookie.get('X-Admin-Token') }
    }
  },
  methods: {
    getUrl(url){
			return previewUrl(url);
		},
    delImg(index,arr) {
      arr.splice(index,1);
    },
    upHandle() {
      this.submitting = true;
      let prams = {
        templateId:this.questionsContent.id
      },isOK = true;
      for(var i=0;i<this.questionsContent.template.length;i++){
        if(this.questionsContent.template[i].options.required==true && (!this.questionsContent.template[i].answer || !this.questionsContent.template[i].answer.length)){
          this.$message({
            message: `请完成第${i+1}题`,
            type: "warning"
          });
          isOK = false;
          this.submitting = false;
          break;
        }
        prams[this.questionsContent.template[i].field] = this.questionsContent.template[i].answer;
      }
      if(!isOK)return
      this.$http.post(this.$api.questions.submitForm, prams).then(({ data }) => {
        this.submitting = false;
        this.$message({
          message: data.msg,
          type: "success"
        });
        this.getList();
      }).catch(()=>{
				this.submitting = false;
			});
    },
    handleAvatarSuccess(res,arr) {
      if(res && res.code==200){
        arr.push(res.data.storage.filePreviewUrl);
      }else{
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    },
    getList() {
      this.$http.get(this.$api.questions.getList+'?t='+new Date().getTime()).then(({ data }) => {
        data.data.template.forEach(v=>{
          if(['check','image'].includes(v.type)){
            v.answer = !v.answer ? [] :v.answer;
          }
        });
        this.questionsContent = data.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  margin-top: -16px;
  background: linear-gradient(180deg, #1460AE 0%, #B4CCE5 35%, #F0F8FF 100%);
  min-height: 610px;

  .guide {
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    padding-bottom: 16px;
    padding-top: 16px;
    display: block;

    div {
      display: inline-block;
    }

    ::v-deep .el-breadcrumb__separator {
      color: #fff;
    }
  }

  .info {
    min-height: 610px;
    margin: 0 auto;
    width: 800px;
    padding: 32px;

    &>div {
      background: #FFF;
      border-radius: 8px;
    }

    .title {
      text-align: center;
      min-height: 120px;
      padding: 26px 0;
      p{
        line-height: 22px;
      }
    }

    .items {
      padding: 24px;
      margin-top: 8px;

      h3 {
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 15px;
        span{
          color: #FF6F77;
        }
      }

      .el-textarea {
        width: 672px;
        margin-top: 22px;
        padding-left: 38px;
      }

      label.el-radio,
      .el-checkbox {
        display: block;
        margin-bottom: 34px;
      }

      .el-radio-group,
      .el-checkbox-group {
        margin-top: 31px;
        padding-left: 38px;
      }
    }
  }
}
.upload-list li{
  width: 88px;
  height: 88px;
  border-radius: 4px;
  border: 1px solid #DEDEDE;
  margin-right: 8px;
  margin-bottom: 8px;
  display: inline-block;
  position: relative;
  img{
    width: 100%;
    height: 100%;
  }
  .del{
    width: 16px;
    height: 16px;
    color: #FF6F77;
    display: none;
    position: absolute;
    right: 6px;
    top: 6px;
  }
  &:hover{
    .del{
      display: block;
      cursor: pointer;
    }
  }
}
.uploader {
  width: 86px;
  height: 86px;
  display:inline-block;
  vertical-align: middle;

  ::v-deep .el-upload {
    height: 100%;
    width: 100%;
  }

  ::v-deep .el-upload--picture-card {
    background-color: unset;
    border: unset;
    border-radius: unset;
    line-height: unset;
  }

  i {
    margin-top: 23px;
    padding-bottom: 10px;
    width: 100%;
    color: #999;
    font-size: 20px;
  }
}
.bottom_btns{
  padding-top: 54px;
  padding-bottom: 60px;
  ::v-deep .el-loading-mask{
    opacity: .3;
  }
}

</style>
